import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { UsersService } from '../users.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CreateOrganisationHierarchyService } from '../../create-organisation-hierarchy/create-organisation-hierarchy.service';
import { TabsService } from '../../../tabs.service';

@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.scss']
})
export class UserEditComponent implements OnInit {
	Form:FormGroup;
	groupsData:any;
	rolesData:any;
	orgLevels: any = [];
	selectedRole: any;
	organisationHierarchy: any = [];
	organisationId: string = '';
	role: string = 'user';
	emailRegex = /^\S+@\S+\.\S+$/;
	orgCode = '';

	constructor(private fb: FormBuilder,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialog: MatDialog,
		private spinner: NgxSpinnerService,
		public dialogRef: MatDialogRef<UserEditComponent>,
		private usersService: UsersService,
		private snackbar: MatSnackBar,
		private tabsService: TabsService,
		private createOrganisationService: CreateOrganisationHierarchyService
	) {
		// console.log('Dataaaa',data);
		if(this.data.role) {
			this.role = this.data.role;
		}
		const d = this.data.userData || {};
		// console.log('editing data', d);

		if (d?.level) {
			this.data['level'] = d.level;
		}

		this.Form = this.fb.group({
			status: [d?.status || d.status === false ? d.status : true, Validators.required],
			id: [d && d.empCode ? d.empCode : d.email, Validators.required],
			name: [d && d.name ? d.name : '', Validators.required],
			password: [d && d.password ? d.password : '', [Validators.minLength(8), Validators.maxLength(128)]],
			groupId: [d && d.groupId ? d.groupId : ''],
			roleId: [d && d.roleId ? d.roleId : '', Validators.required],
			email: [d && d.email ? d.email : ''],
			phone: [d && d.phone ? d.phone : ''],
			role: [d && d.role ? d.role : '', Validators.required],
			level: [d && d.level ? d.level : [], Validators.required],
			createdAt: [d && d.createdAt ? this.getFormattedDate(d.createdAt) : '', Validators.required],
			updatedAt: [d && d.updatedAt ? this.getFormattedDate(d.updatedAt) : '', Validators.required],
			organisationId: this.data.organisationId,
		});

		if (this.data?.editLevels) {
			const editLevels = this.data.editLevels;
			// console.log(editLevels);

			for (let i = 0; i < editLevels.length; i += 1) {
				let editLevel = editLevels[i];

				this.Form.value['level'][i] = {
					name: editLevel.name,
					value: editLevel.value
				};
			}
		}

		this.tabsService.organisationId$.subscribe(async organisationId => {
			this.organisationId = organisationId;
			this.organisationHierarchy = await this.createOrganisationService.getOrganisationHierarchy(this.organisationId);
		});

		this.orgCode = this.data.orgCode ?? '';
		// console.log(this.orgCode);
	}

	async ngOnInit(): Promise<void> {
		this.getGroups();
		this.getRoles();
		this.orgLevels = await this.usersService.getOrganizationLevels();
	}

	changeLevel(levelName: string) {
		const level = this.orgLevels.find((o: any) => o.name === levelName);
		if (!this.data) {
			this.data = {};
		}
		this.data['level'] = JSON.parse(JSON.stringify(level));
	}

	onChangeLevelValue(ev: any, index: number) {
		const levelIndex: number = this.orgLevels.findIndex((o: any) => o.name === this.data.level.name);
		const orgValue = this.orgLevels[levelIndex].values[index];

		if (ev.checked) {
			this.data.level.values.push(orgValue);
		} else {
			const indexOfValue = this.data.level.values.findIndex((item: any) => item === orgValue);
			this.data.level.values.splice(indexOfValue, 1);
		}
	}

	getValues() {
		const levelIndex: number = this.orgLevels.findIndex((o: any) => o.name === this.data.level.name);
		const values = this.orgLevels[levelIndex].values;
		let valueArr: any = [];

		for (let value of values) {
			if (!valueArr.includes(value)) {
				valueArr.push(value);
			}
		}

		return valueArr;
	}

	isValueSelected(value: string) {
		return this.data.level.values.includes(value);
	}

	changeGroup(value: any) {
		// console.log('select option clicked',value)
	}

	changeRole(item: any) {
		this.selectedRole = item.name;
	}

	changeUserStatus(event: any) {
		this.Form.value['status'] = event.checked;
	}

	getGroups(){
		this.usersService.getGroups(this.data.organisationId).subscribe((group) => {
			if (group.length > 0) {
				this.groupsData  = group;
				// console.log(this.groupsData)
			}
		});
	}

	getRoles() {
		this.usersService.getRoles(this.data.organisationId).subscribe((role) => {
			if(role.length > 0) {
				this.rolesData = role;
				// console.log('this.rolesData',this.rolesData)
				this.rolesData.forEach((el:any) => {
					// console.log(el)
					if(el.name === this.role){
						// console.log(el);
						this.Form.patchValue({
							roleId: el.id,
						  });
					}
				})
			}
		});
	}

	async saveBtn() {
		// console.log('form', this.Form.value);
		// console.log("data", this.data);

		// * Required field check
		if (this.Form.value.name === '' || !this.Form.value.name || this.Form.value.roleId === '' || !this.Form.value.roleId || this.Form.value.id === '' || !this.Form.value.id) {
			this.snackbar.open('Please enter required details', 'ok', { duration: 1000 });
			return;
		}

		if (!this.data.userData && this.Form.value.password === '') {
			this.snackbar.open('Please enter password', 'ok', { duration: 1000 });
			return;
		}

		if (this.Form.controls['password'].invalid) {
			this.snackbar.open('Password must be between 8 and 128 characters.', 'ok', { duration: 2500 });
			return;
		}

		await this.spinner.show("blockLoader");
		// this.Form.value['level'] = this.data.level;
		let doesUserExist: any = false;

		if (!this.data?.userData) {
			// console.log(this.Form.controls['email'].value);
			doesUserExist = await this.usersService.checkIfUserExists(this.Form.controls['email'].value);
			if (!doesUserExist) {
				// doesUserExist = await this.usersService.checkIfUserExistsByCode(String(this.Form.value['id']).toLowerCase());
				doesUserExist = await this.usersService.checkIfUserExistsByCodeInOrg(String(this.Form.value['id']).toLowerCase(), this.organisationId);
			}
			await this.spinner.hide("blockLoader");

			if (doesUserExist) {
				this.snackbar.open("A user already exists by this id!", "OK");
			} else {
				this.Form.value['createdAt'] = new Date();
				delete this.Form.value['role'];
				if (this.emailRegex.test(this.Form.value['id'])) {
					this.Form.value['email'] = this.Form.value['id'];
				} else {
					this.Form.value.empCode = String(this.Form.value['id']).toLowerCase();
				}

				if (!this.Form.value['email']) {
					this.Form.value['email'] = `${this.Form.value.empCode.toLowerCase()}@${this.orgCode.toLowerCase()}.ignite`;
				} else {
					this.Form.value['email'] = String(this.Form.value['email']).toLowerCase().trim();
				}
			}
		} else {
			if (this.data.userData.empCode) {
				this.Form.value['empCode'] = this.data.userData.empCode;
			}
		}

		if (this.Form.value['id']) {
			delete this.Form.value['id'];
		}

		if (!doesUserExist) {
			try {
				await this.usersService.addEditUser(this.Form.value, this.data.userData ? this.data.userData.id : '');
				this.dialogRef.close({
					status: 'success',
					newUser: this.Form.value
				});
			} catch (error: any) {
				const errorMessage = error?.message || 'Unable to save the user.';
				this.snackbar.open(errorMessage, 'OK', { duration: 3500 });
			} finally {
				await this.spinner.hide("blockLoader");
			}
		}
	}

	getFormattedDate(date: any) {
		if (!date.seconds && !date.nanoseconds && (date._seconds || date._seconds === 0) && (date._nanoseconds || date._nanoseconds === 0)) {
			return new Date(date._seconds * 1000);
		} else if ((date.seconds || date.seconds === 0) && (date.nanoseconds || date.nanoseconds === 0) && !date._seconds && !date._nanoseconds) {
			return new Date(date.seconds * 1000);
		} else {
			return date.toDate();
		}
	}

	// checkCryptoSupport() {
	// 	// console.log('window.crypto', window.crypto);
	// 	// console.log('crypto.subtle', crypto.subtle);
	// 	// console.log('window.TextEncoder', window.TextEncoder);
	// 	return window.crypto && crypto.subtle && window.TextEncoder;
	// }

	uniqueOrgLevelValues(values: any, index: number) {
		let uniqueVals: any = [];

		if (index === 0) {
			for (let val of values) {
				let doesExist: boolean = false;

				for (let item of uniqueVals) {
					if (item.value === val.value) {
						doesExist = true;
						break;
					}
				}

				if (!doesExist) {
					uniqueVals.push(val);
				}
			}
		} else {
			let allPreviousLevelValue = [];
			for (let i = 0; i < index; i += 1) {
				allPreviousLevelValue.push(this.levelValue(i));
			}
			if (allPreviousLevelValue.length >= 1) {
				const currentHierarchy = this.organisationHierarchy[index].values;
				for (let currentValue of currentHierarchy) {
					let isValid: boolean = true;
					let currentValueLevels = currentValue.levels;

					for (let i = 0; i < currentValueLevels.length; i += 1) {
						if (currentValueLevels[i] !== allPreviousLevelValue[i]) {
							isValid = false;
							break;
						}
					}

					if (isValid) {
						// console.log(currentValue.value);
						uniqueVals.push(currentValue);
					}
				}
			}
		}

		return uniqueVals;
	}

	selectionVal(orgLevel: any, tempLevel: any) {
		return {
			name: orgLevel.name,
			value: tempLevel.value
		}
	}

	changeLevelOption(index: number, orgLevelName: string, levelValue: string) {
		// console.log(levelValue);
		if (levelValue === "none") {
			this.Form.value['level'].splice(index, this.Form.value['level'].length);
		} else {
			this.Form.value['level'][index] = {
				name: orgLevelName,
				value: levelValue
			};
		}
	}

	levelValue(index: number) {
		if (this.Form.value['level'][index]) {
			return this.Form.value['level'][index].value;
		}

		return "";
	}

	async deleteUserProgress(userId: string) {
		await this.spinner.show("blockLoader");
		const deletionRes = await this.usersService.deleteUserProgress(userId);
		await this.spinner.hide("blockLoader");

		if (deletionRes.status === 'success') {
			this.snackbar.open("User progress from all programs has been deleted!", "OK");
		} else if (deletionRes.status === 'not-required') {
			this.snackbar.open("This user is not enrolled in any program yet!", "OK");
		} else if (deletionRes.status === 'failed') {
			this.snackbar.open("Unable to delete progress for this user!", "OK");
		}
	}

	isUserAdmin() {
		return this.role === 'admin';
	}

	changeInIdField() {
		// console.log(this.Form.value['id']);
		if (this.emailRegex.test(this.Form.value['id'])) {
			this.Form.value['email'] = this.Form.value['id'];
			this.Form.controls['email'].setValue(this.Form.value['id']);
			this.Form.controls['email'].disable();
			delete this.Form.value['empCode'];
		} else {
			this.Form.controls['email'].enable();
			this.Form.value.empCode = this.Form.controls['email'].value;
		}
	}

	capitalizeFirstWord(word: string) {
		return word.charAt(0).toUpperCase() + word.slice(1);
	}
}
